



































import Vue from 'vue';
// import item, { Item } from '@/modules/exhibitor/item';
// import brand, { Brand } from '@/modules/exhibitor/brand';
import {
  item,
  Item,
  brand,
  Brand,
} from 'mostra';

interface DataType {
  loading: boolean;
  selectedBrand: string;
  brands: Brand[] | null;
  loads: Item[];
  currentIndex: number;
  loadsLength: number;
  pagerLength: number;
  maxDisplayedItemLength: number;
  maxPagerLength: number;
  listItems: Item[];
  pagerItems: number[];
  owner: string | null
}

export default Vue.extend({
  name: 'exhibitor-item-top',
  data(): DataType {
    return {
      loading: true,
      selectedBrand: '',
      brands: null,
      loads: [],
      currentIndex: 1,
      loadsLength: 0,
      maxDisplayedItemLength: 30,
      pagerLength: 0,
      maxPagerLength: 8,
      listItems: [],
      pagerItems: [],
      owner: null,
    };
  },
  watch: {
    loads(array: any) {
      if (array) {
        this.loadsLength = array.length;
        this.pagerLength = Math.ceil(
          array.length / this.maxDisplayedItemLength,
        );
        this.createList(this.currentIndex);
      }
    },
    currentIndex(index: number) {
      this.createList(index);
    },
  },
  methods: {
    toCreatePage() {
      this.$router.push({
        name: 'exhibitor-item-new',
        query: { page: 'settings' },
      });
    },
    toEditData(id: string) {
      this.$router.push({
        name: 'exhibitor-item-edit',
        query: { page: 'preview', id: id },
      });
    },
    copyItem(id: string) {
      this.$router.push({
        name: 'exhibitor-item-copy',
        query: { page: 'settings', copy: id },
      });
    },
    previewItem(id: string) {
      console.log(id, 'プレビュー');
    },
    createList(index: number) {
      const startIndex = (index - 1) * this.maxDisplayedItemLength;
      this.listItems = [];
      for (let i = 0; i < this.maxDisplayedItemLength; i++) {
        if (!this.loads[startIndex + i]) break;
        this.listItems.push(this.loads[startIndex + i]);
      }
    },
    setPagerItems(list: number[]) {
      this.pagerItems = list;
    },
    prevPage() {
      if (this.currentIndex <= 1) return;
      this.currentIndex--;
    },
    changePage(index: number) {
      this.currentIndex = index;
    },
    nextPage() {
      if (this.currentIndex >= this.pagerLength) return;
      this.currentIndex++;
    },
    onAddErrorNotification(text: string) {
      this.$stores.notifications.addErrorNotification(text);
    },
    async filterByBrand(value: string) {
      this.selectedBrand = value;
      await this.fetchItemByBrand(value);
    },
    async fetchItemByBrand(brandId: string) {
      try {
        // const uid = this.$auth.uid;
        // this.loading = true;
        this.$loading(true);
        if (!brandId) {
          this.loads = await item.loadsByOwner(this.$auth.cid);
          return;
        }
        this.loads = await item.loadsByBrandId(this.$auth.cid, brandId);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        // this.loading = false;
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        const cid = this.$auth.cid;
        this.loading = true;
        this.$loading(true);
        this.owner = this.$auth.cid;
        if (this.loads.length < 1) {
          this.loads = await item.loadsByOwner(cid);
        }
        if (this.brands === null) {
          this.brands = await brand.loadsByOwner(cid);
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    await this.fetchData();
  },
});
